import React from "react";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  accessLevel: state.accessLevel.item
});

class AccessLevelSubmitted extends React.Component {
  componentWillMount() {
    const { accessLevel } = this.props;
    if (!accessLevel.id) {
    }
  }

  render() {
    const { accessLevel } = this.props;
    if (!accessLevel.id) {
      return "Ingen informasjon/Sesjon er utløpt";
    }
    return (
      <React.Fragment>
        <div className="page-header">
          <h1>Adgangsnivå - Bestilling innsendt</h1>
        </div>

        <table className="table table-striped">
          <thead>
            <tr>
              <th>Innsendt informasjon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Bestillers navn</th>
              <td>{accessLevel.orderer}</td>
            </tr>
            <tr>
              <th>Adgangsnivå (Betegnelse)</th>
              <td>{accessLevel.name}</td>
            </tr>
            <tr>
              <th>Lesere</th>
              <td>
                {accessLevel.readers.map(reader => (
                  <li key={`reader-${reader.id}`}>{reader.name}</li>
                ))}
              </td>
            </tr>
            <tr>
              <th>Merknader</th>
              <td>{accessLevel.note}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(AccessLevelSubmitted);



// WEBPACK FOOTER //
// ./src/components/AccessLevelSubmitted.js